import {round} from './mathHelper'

export function formatPrice (prc) {
  return round(prc, 2).
    toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
}
